import {
  DEFAULT_DATA_CREDITS_VALUE_MAP,
  DEFAULT_DATA_SPEED_DOWN_VALUE_MAP,
  DEFAULT_MONTHLY_FEE_VALUE_MAP,
  DEFAULT_PRICE_VALUE_MAP,
  DEFAULT_VOICE_CREDITS_VALUE_MAP
} from "../../filters";

export const DATA_CREDITS_VALUE_MAP = DEFAULT_DATA_CREDITS_VALUE_MAP;
export const DATA_SPEED_DOWN_VALUE_MAP = DEFAULT_DATA_SPEED_DOWN_VALUE_MAP;
export const MONTHLY_FEE_VALUE_MAP = DEFAULT_MONTHLY_FEE_VALUE_MAP;
export const PRICE_VALUE_MAP = DEFAULT_PRICE_VALUE_MAP;
export const VOICE_CREDITS_VALUE_MAP = DEFAULT_VOICE_CREDITS_VALUE_MAP;
